module.exports = __webpack_public_path__ + "img/big_1_4.9efb914e.png";